import ChannelLinks from './channel-links.es6';
import Formatter    from 'bufferformatter';
import Dialog       from 'dialogview';
import Keyboard     from '../lib/keyboard.es6';
import template     from './channel-switch-dialog.hbs';
import { score }    from 'fuzzaldrin-plus';
import unorm        from 'unorm';
import { normaliseChan } from '../lib/util.es6';
import './channel-switch-dialog.scss';

let Super = Dialog.prototype;

const INIT_STATE = { filtered: [], current: 0 };

export default Dialog.extend({

    showInstant: true,
    hideInstant: true,

    template,

    className: 'channelSwitchDialog accountContainer form',

    events: $.extend({}, Super.events, {
        'keyup .channelSwitchDialog__input' : onInput
    }),

    initialize (options) {
        Super.initialize.apply(this, arguments);
        this.selectBuffer = selectBuffer.bind(this);
        this.channelLinks = new ChannelLinks({
            select: this.selectBuffer
        });
        this.setInitialState();

        // cmd + k 
        $(window).on('keydown', (e) => {
            if (Keyboard.isModifier(e) && e.which === Keyboard.KEYS.K) {
                e.preventDefault();
                this.toggle();
            }
        });
    },
        

    setInitialState () {
        this.setState(INIT_STATE);
    },

    setState (state) {
        this.channelLinks.setState(state);
    },

    render () {
        // right now we only render this dialog once, but if we would render 
        // it more than once, we'd need to re-delegate events on the subviews 
        // as `.html` calls `.empty` internally on all the element’s descendants 
        this.$el.html(this.template());
        this.afterRender();
        return this;
    },

    afterRender () {
        this.$input = this.$el.find('.channelSwitchDialog__input');
        this.$channelLinks = this.$el.find('.channelSwitchDialog__channelLinks');
        this.$channelLinks.append(this.channelLinks.el);
    },

    filter (query, force) {
        query = query.replace(/\s/g, '');
        query = normaliseChan(query);

        if (!force && query === this.prevQuery) {
            return;
        }

        if (query && this.fuzzyFilter) {
            let filtered = this.fuzzyFilter(query);
            let currentBuffer;
            let currentBufferKey;

            if (this.model.currentBuffer) {
                currentBufferKey = this.model.currentBuffer.bid();
            }

            filtered = filtered.filter(candidate => {
                // filter current buffer out to push it to the end of the list
                if (candidate.bid === currentBufferKey) {
                    currentBuffer = candidate;
                    return false;
                } else {
                    return true;
                }
            });
            if (currentBuffer) {
                filtered.push(currentBuffer);
            }
            // debug.table(filtered);
            this.setState({ filtered, current: 0 });
        } else {
            this.setInitialState();
        }

        this.prevQuery = query;
    },

    opened () {
        Super.opened.apply(this, arguments);
        this.$input.val('');
        this.setFilter();
        this.channelLinks.setup();
        this.$input.focus();
    },

    setFilter () {
        this.data = getData.call(this);
        this.fuzzyFilter = getFuzzyFilter(getConnections(this.model), this.data.buffers);
    },

    runFilter (force) {
        this.filter(this.$input.val(), force);
    },

    closed () {
        this.$input.val('');
        this.setInitialState();
        this.data = null;
        this.fuzzyFilter = null;
        this.channelLinks.teardown();
        Super.closed.apply(this, arguments);
    }
});

function onInput (e) {
    if (e.which === Keyboard.KEYS.UP || e.which === Keyboard.KEYS.DOWN) {
        return;
    }

    this.runFilter();
}

function selectBuffer (selection) {
    if (selection.bid) {
        var buffer = selection.connection.getBuffer(selection.bid);
        if (buffer) {
            buffer.select();
        }
    } else {
        selection.connection.openBuffer(selection.name);
    }
    this.hide();
}

let _archiveNames = null;
let _fetchingArchives = false;
function fetchArchiveNames () {
    if (_archiveNames || _fetchingArchives) {
        return;
    }
    this.$el.addClass('loading');
    _fetchingArchives = true;
    this.model.backend.get('archive-names', {}, (response) => {
        if (!response.error && response.success !== false) {
            _archiveNames = response;
            this.setFilter();
            this.runFilter(true);
        }
        this.$el.removeClass('loading');
        _fetchingArchives = false;
    });
}

function getData () {
    let buffers = [];
    this.model.connections.forEach((connection) => {
        let connectionName = connection.getDisplayName();
        let bufferUrls = {}; // dupe checking
        connection.buffers.channels.models
            .concat(connection.buffers.conversations.models)
            .forEach((buffer) => {
                let displayName = buffer.getDisplayName();
                if (buffer.isChannel()) {
                    let safeChanSuffix = buffer.safeChanSuffix();
                    if (safeChanSuffix) {
                        displayName += ' ' + safeChanSuffix;
                    }
                }
                let bufferUrl = buffer.url();
                bufferUrls[bufferUrl] = true;
                buffers.push({
                    connection: connection,
                    bid: buffer.bid(),
                    type: buffer.getType(),
                    name: buffer.getName(),
                    displayName: displayName,
                    href: bufferUrl,
                    archived: buffer.isArchived(),
                    active: buffer.isActive(),
                    searchKey: prepareSearchKey(buffer.normalise() + connectionName),
                    serverName: connectionName
                });
            });
        if (connection.hasDeferredArchives()) {
            fetchArchiveNames.call(this);
        }
        if (_archiveNames && _archiveNames[connection.id]) {
            let formatter = new Formatter(connection.serverLog);
            _archiveNames[connection.id].forEach((name) => {
                let isChannel = formatter.linker.isChannelName(name);
                let urlNamespace = isChannel ? 'channel' : 'messages';
                let type = isChannel ? 'channel' : 'conversation';
                let urlName = isChannel ? connection.channelSlug(name) : name;
                let bufferUrl = connection.buildUrl([urlNamespace, urlName]);
                if (bufferUrls[bufferUrl]) {
                    return;
                }
                let displayName = name;
                if (isChannel) {
                    let dummyChannel = connection.makeChannel({name: name});
                    displayName = dummyChannel.getDisplayName();
                    let safeChanSuffix = dummyChannel.safeChanSuffix();
                    if (safeChanSuffix) {
                        displayName += ' ' + safeChanSuffix;
                    }
                }
                buffers.push({
                    connection: connection,
                    type: type,
                    name: name,
                    displayName: displayName,
                    href: bufferUrl,
                    archived: true,
                    active: false,
                    searchKey: prepareSearchKey(connection.normaliseBufferName(name) + connectionName),
                    serverName: connectionName
                });
            });
        }
    });
    
    return { buffers };
}

function indexOfScorer (term, query) {
    let position = term.indexOf(query);
    if (position === -1) {
        return 0;
    }
    return 1 / (position + 1);
}

function getFuzzyFilter (connections, buffers) {
    return function fuzzyFilter (query) {
        return buffers.concat()
            .map((b, i) => {
                b.score = score(b.searchKey, query);
                b.indexOfScore = indexOfScorer(b.searchKey, query);
                b.connectionOrder = connections[b.connection.id];
                return b;
            })
            .filter(b => b.score > 0)
            .sort((a, b) => {
                let archiveSort = a.archived - b.archived;
                let activeSort = b.active - a.active;
                let indexOfSort = b.indexOfScore - a.indexOfScore;
                let scoreSort = b.score - a.score;
                let orderSort = a.connectionOrder - b.connectionOrder;
                
                if (archiveSort !== 0) {
                    return archiveSort;
                }

                if (activeSort !== 0) {
                    return activeSort;
                }

                if (indexOfSort !== 0) {
                    return indexOfSort;
                }

                if (scoreSort !== 0) {
                    return scoreSort;
                }

                return orderSort;
            });
            
    };
}

function getConnections (session) {
    return session.connections.reduce((connections, conn, i) => {
        connections[conn.id] = i;
        return connections;
    }, {});
}

function prepareSearchKey (searchKey) {
    // convert emoji to text
    // decompose the string to ascii + diacritic mark and remove the mark
    // i.e. é = U+0065 U+0301 = e ´
    // `String::normalize('NFKD')` is not available in Safari and IE
    return unorm.nfkd(emoji.unified_to_text(searchKey)).replace(/[\u0300-\u036F]/g, '');
}



// WEBPACK FOOTER //
// ./app/src/view/channel-switch-dialog.es6